import { Component, OnInit, Output, EventEmitter, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { ManagementApiService } from 'src/app/services';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
import { OrganizationDataService } from 'src/app/services/organization-data.service';
import { RouteServiceService } from 'src/app/services/route-service.service';
import { MsalService, MsalBroadcastService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import {
    EventMessage,
    EventType,
    InteractionType,
    InteractionStatus,
    PopupRequest,
    RedirectRequest,
    AuthenticationResult,
    PublicClientApplication,
    IPublicClientApplication,
} from '@azure/msal-browser';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import jwt_decode from 'jwt-decode';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { WarningDialogComponent } from 'src/app/shared/info-dialogs/warning-dialog/warning-dialog.component';
import { Subscription } from 'rxjs';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { ErrorDialogComponent } from 'src/app/shared/info-dialogs/error-dialog/error-dialog.component';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { LogoNames } from 'src/app/shared/enums/logoNames.enum';
import { FullUserData } from 'src/app/Modules/management/models/organization/fullUserData.model';
import { EmailNewOrgAdd } from 'src/app/models/Emails.model';
import { EmailSenderService } from 'src/app/services/email-sender.service';
import { EmailType } from 'src/app/models/enums/email-type.enum';
import { environment } from 'src/environments/environment';
import { OrganizationUserModel } from 'src/app/Modules/management/models/organization/organization-user.model';
import { EnvironmentService } from 'src/app/services/environment.service';
interface Payload extends AuthenticationResult {
    idTokenClaims: {
        tfp?: string;
    };
}
@Component({
    selector: 'app-landing-header',
    templateUrl: './landing-header.component.html',
    styleUrls: ['./landing-header.component.scss'],
    standalone: false,
})
export class LandingHeaderComponent implements OnInit {
    private readonly _destroying$ = new Subject<void>();
    @Output() isAdmin = new EventEmitter<string>();

    IA = LogoNames.IA;
    isIframe = false;
    loginDisplay = false;
    headerContainerCSSClasses: string;
    headerMenuSelfDisplay: boolean;
    headerMenuSelfStatic: boolean;
    asideSelfDisplay: boolean;
    headerLogo: string;
    headerSelfTheme: string;
    headerMenuCSSClasses;
    headerMenuHTMLAttributes: any = {};
    ulCSSClasses: string;
    rootArrowEnabled: boolean;
    location: Location;
    headerMenuDesktopToggle: string;
    display = 'none';
    userFormData = new FormData();
    decodedToken: any;
    systemAdmin: boolean;
    accountName = '';
    loggedIn = false;
    isSystemAdmin = '';
    flagLogin = true;
    currentOrg: string;
    currentOrgId: string;
    currentInstance: string;
    profile: any;
    oid: string;
    dialogRef: any;
    closeResult: string;
    isUserShown: boolean;
    isUserDropdown: boolean;
    isUserDropdownOpen = false;
    loggedInUserDetail: FullUserData;
    currentlySignUpUser: FullUserData;
    organizationUser: OrganizationUserModel;
    subscriptions: Subscription[] = [];

    constructor(
        @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
        private authService: MsalService,
        private msalBroadcastService: MsalBroadcastService,
        private router: Router,
        private managementApiService: ManagementApiService,
        private user_utility: UserUtilityService,
        private globalEmittersService: GlobalEmittersService,
        private routeServiceService: RouteServiceService,
        private organizationDataService: OrganizationDataService,
        private modalService: NgbModal,
        private ngxUiLoaderService: NgxUiLoaderService,
        private emailSenderService: EmailSenderService,
        private EnvironmentService: EnvironmentService
    ) {}

    ngOnInit(): void {
        this.user_utility.isLicenseChecked = false;
        this.isIframe = window !== window.parent && !window.opener;
        this.setLoginDisplay();
        this.msalBroadcastService.inProgress$
            .pipe(
                filter((status: InteractionStatus) => status === InteractionStatus.None),
                takeUntil(this._destroying$)
            )
            .subscribe(() => {
                this.setLoginDisplay();
                this.checkAndSetActiveAccount();
            });

        this.msalBroadcastService.msalSubject$
            .pipe(
                filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS || msg.eventType === EventType.ACQUIRE_TOKEN_SUCCESS),
                takeUntil(this._destroying$)
            )
            .subscribe((result: EventMessage) => {
                const payload: Payload = <AuthenticationResult>result.payload;

                if (payload.idTokenClaims['tfp'] === environment.b2cPolicies.names.editProfile) {
                    window.alert('Profile has been updated successfully. \nPlease sign-in again.');
                    this.logout();
                    return;
                }
            });

        this.msalBroadcastService.msalSubject$
            .pipe(
                filter((msg: any) => msg.eventType === EventType.LOGIN_FAILURE || msg.eventType === EventType.ACQUIRE_TOKEN_FAILURE),
                takeUntil(this._destroying$)
            )
            .subscribe((result: any) => {
                const forgetPasswordFlowRequest = {
                    scopes: environment.scopes,
                    authority: environment.b2cPolicies.authorities.resetPassPolicy.authority,
                };
                if (result.error.errorMessage.indexOf('AADB2C90037') > -1) {
                    this.authService.loginPopup(forgetPasswordFlowRequest);
                }
                console.error('MSAL Login/Token Error:', result.error);
            });

        this.msalBroadcastService.msalSubject$
            .pipe(filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS))
            .pipe(takeUntil(this._destroying$))
            .subscribe((result: any) => {
                localStorage.setItem('msal.accessToken', result.payload.accessToken);
                if (result) {
                    this.oid = result?.payload?.account?.idTokenClaims?.oid || result.payload?.account?.idTokenClaims?.sub;
                    const payload = result.payload as AuthenticationResult;
                    this.authService.instance.setActiveAccount(payload.account);
                    this.ngxUiLoaderService.start();
                    if (result.payload.authority === environment.b2cPolicies.authorities.signUp.authority.toLowerCase()) {
                        this.managementApiService
                            .addDemoUser()
                            .pipe(takeUntil(this._destroying$))
                            .subscribe(
                                (res) => {
                                    if (res.success === true) {
                                        this.currentlySignUpUser = res.response;
                                        this.ngxUiLoaderService.stop();
                                        this.getAccountName();
                                        this.getFullUserData();
                                        this.router.navigate(['/home']);
                                        if (res.response.isDemoUser) {
                                            this.triggerEmail();
                                        }
                                    } else {
                                        this.user_utility.errorModelPopup(res.message);
                                        this.ngxUiLoaderService.stop();
                                    }
                                },
                                (err) => {
                                    this.ngxUiLoaderService.stop();
                                    console.error('Add Demo User Error:', err);
                                    this.user_utility.errorModelPopup('Error adding demo user.');
                                }
                            );
                    } else {
                        this.getAccountName();
                        this.getFullUserData();
                    }
                }
            });

        this.msalBroadcastService.inProgress$
            .pipe(filter((status: InteractionStatus) => status === InteractionStatus.None))
            .pipe(takeUntil(this._destroying$))
            .subscribe(() => {
                this.setLoginDisplay();
            });
    }

    isLoggedIn() {
        return !!this.authService.instance.getActiveAccount();
    }

    getAccountName() {
        this.accountName = this.authService.instance.getActiveAccount().idTokenClaims.name;
        //Case of demo user, name will be unknown, so construct the name using surname and firstname
        if (this.accountName === 'unknown') {
            if (this.authService.instance.getActiveAccount().idTokenClaims?.surname) {
                this.accountName =
                    this.authService.instance.getActiveAccount().idTokenClaims.surname +
                    ',' +
                    this.authService.instance.getActiveAccount().idTokenClaims.firstname;
            } else {
                this.accountName =
                    this.authService.instance.getActiveAccount().idTokenClaims.family_name +
                    ',' +
                    this.authService.instance.getActiveAccount().idTokenClaims.given_name;
            }
        }
        return this.accountName;
    }

    getFullUserData() {
        if (this.accountName.length > 0 && this.flagLogin) {
            let token = localStorage.getItem('msal.accessToken');
            this.decodedToken = this.getDecodedAccessToken(token);
            // this.globalEmittersService.initiateInterval.next(true);  // * initiate time interval
            this.ngxUiLoaderService.start();
            this.managementApiService.getFullUserDetailAfterLogin().subscribe(
                (result) => {
                    //check license first
                    this.ngxUiLoaderService.stop();
                    this.loggedInUserDetail = result.response;
                    if (result?.message?.length > 0) {
                        let dialogRef = this.modalService.open(ErrorDialogComponent, {
                            size: 'sm',
                            backdrop: 'static',
                            keyboard: false,
                        });
                        dialogRef.componentInstance.message = result.message;
                        dialogRef.result
                            .then((res) => {
                                if (res) {
                                    if (result.success === false) {
                                        this.user_utility.logout();
                                    } else {
                                        this.user_utility.setUserData(result.response);
                                        this.globalEmittersService.profileDetails.next(result.response);
                                        // if (this.checkLicenseValid()) {
                                        if (this.user_utility.getUserData().isSysAdmin === true) {
                                            this.isSystemAdmin = this.user_utility.getUserSecurityRoleName();
                                            this.isAdmin.emit(this.isSystemAdmin);
                                            //set security level
                                            this.routeServiceService.enableRoute = this.isSystemAdmin ? true : false;
                                            this.systemAdmin = true;
                                            this.router.navigate(['/home']);
                                        } else {
                                            this.setOrganization();
                                            this.handleInstance();
                                            this.router.navigate(['/home']);
                                        }
                                        // * this is to get the user-defaults data directly after the login/sign up
                                        this.managementApiService.postLogin();
                                    }
                                }
                            })
                            .catch((error) => {
                                console.warn(error);
                            });
                    } else if (result.success === true) {
                        this.user_utility.setUserData(result.response);
                        this.globalEmittersService.profileDetails.next(result.response);
                        // if (this.checkLicenseValid()) {
                        if (this.user_utility.getUserData().isSysAdmin === true) {
                            this.isSystemAdmin = this.user_utility.getUserSecurityRoleName();
                            this.isAdmin.emit(this.isSystemAdmin);
                            //set security level
                            this.routeServiceService.enableRoute = this.isSystemAdmin ? true : false;
                            this.systemAdmin = true;
                            this.router.navigate(['/home']);
                        } else {
                            this.setOrganization();
                            this.handleInstance();
                        }
                        // * this is to get the user-defaults data directly after the login/sign up
                        this.managementApiService.postLogin();
                        // if (!this.user_utility.validateSelectedOrgAndInstanceAccess(this.loggedInUserDetail)) {
                        //     return false;
                        // }
                        //}
                    }
                    // else {
                    //     let dialogRef = this.modalService.open(ErrorDialogComponent, {
                    //         size: 'sm',
                    //         backdrop: 'static',
                    //         keyboard: false,
                    //     });
                    //     dialogRef.componentInstance.message = result.message;
                    //     dialogRef.result
                    //         .then((result) => {
                    //             if (result) {
                    //                 // this.authService.logout();
                    //                 // localStorage.clear();
                    //                 this.user_utility.logout();
                    //             }
                    //         })
                    //         .catch((error) => {
                    //             console.warn(error);
                    //         });
                    // }
                },
                (err) => {
                    this.ngxUiLoaderService.stop();
                }
            );

            this.flagLogin = false;
        }
    }

    checkLicenseValid() {
        let licenseValid = this.user_utility.isLicenseValid();
        if (licenseValid) {
            return true;
        } else {
            //disable access to menu
            this.router.navigate(['/home']);
            this.globalEmittersService.isLicenseValid.next(false);
            //license is not valid
            let dialogRef = this.modalService.open(WarningDialogComponent, {
                size: 'sm',
                centered: true,
            });
            dialogRef.componentInstance.message = 'Your License has been expired!';
        }
    }

    setOrganization() {
        let organizations = this.user_utility.getUserData().organisations;
        if (organizations !== undefined && Object.keys(organizations).length > 1) {
            this.globalEmittersService.hideOrgLogoutOption.next(false);
            this.router.navigate(['/management/organization']);
        } else if (organizations !== undefined && Object.keys(organizations).length >= 1) {
            let organization = organizations[0];
            // let organization = this.user_utility.getUserData().organisation;
            this.currentOrg = organization.name;
            this.globalEmittersService.currentOrg.next(organization.name);
            this.globalEmittersService.currentOrgId.next(organization.organisationId);
            this.organizationDataService.currentOrgId = organization.organisationId;
            this.organizationDataService.currentOrg = organization.name;
            localStorage.setItem('selectedOrganizationName', organization.name);
            localStorage.setItem('selectedOrganization', JSON.stringify(organization));
            localStorage.setItem('selectedOrgId', organization.organisationId);
            this.globalEmittersService.hideOrgLogoutOption.next(true);
            this.globalEmittersService.refreshOrgName.next(true);
            // removing the current instance stored in local storage because each organization has different instances
            // on selection on new organization previously selected have to removed
            if (localStorage.getItem('currentInstanceName')) {
                this.globalEmittersService.currentInstanceName.next(null);
            }
        }
    }

    // setInstance() {
    //     let organizations = this.user_utility.getUserData().organisations;
    //     if (this.user_utility.getUserData().hasOwnProperty('organisations') === false) {
    //         this.router.navigate(['/management/instance'], { queryParams: { organizationId: `${localStorage.getItem('selectedOrgId')}` } });
    //     } else if (this.user_utility.getUserData().hasOwnProperty('organisations') && Object.keys(organizations[0].instances).length > 1) {
    //         this.router.navigate(['/management/instance'], { queryParams: { organizationId: `${localStorage.getItem('selectedOrgId')}` } });
    //     } else {
    //         this.globalEmittersService.currentInstanceName.next(organizations[0].instances[0].name);
    //         this.globalEmittersService.currentInstanceId.next(organizations[0].instances[0].instanceId);
    //         localStorage.setItem('currentInstanceName', organizations[0].instances[0].name);
    //         localStorage.setItem('currentInstanceId', organizations[0].instances[0].instanceId);
    //
    //         //setting instance type id
    //         this.globalEmittersService.currentInstanceTypeId.next(organizations[0].instances[0].instanceType.instanceTypeId);
    //         this.router.navigate(['/home']);
    //     }
    // }

    // * handle instance stuff after user loggedIn
    handleInstance() {
        if (this.loggedInUserDetail) {
            if (this.loggedInUserDetail?.organisations !== null && this.loggedInUserDetail?.organisations !== undefined) {
                if (this.loggedInUserDetail?.organisations.length <= 1) {
                    if (this.loggedInUserDetail.organisations[0]?.instances.length > 1) {
                        // * when user have assigned multiple instances
                        this.router.navigate(['/management/instance'], {
                            queryParams: {
                                organizationId: `${localStorage.getItem('selectedOrgId')}`,
                            },
                        });
                        this.globalEmittersService.hideInstanceLogoutOption.next(false);
                    } else if (this.loggedInUserDetail.organisations[0]?.instances.length == 1) {
                        this.globalEmittersService.currentLicenseInstanceTypeIndex.next(this.loggedInUserDetail.license.instanceTypeIndex);
                        if (this.loggedInUserDetail?.organisations && this.loggedInUserDetail.organisations[0]) {
                            localStorage.setItem('selectedOrgId', this.loggedInUserDetail.organisations[0].organisationId);
                        }
                        if (this.loggedInUserDetail.organisations[0].instances[0]?.enabled) {
                            // * when user have only one instance assigned directly selecting that instance for user
                            this.globalEmittersService.currentInstanceId.next(this.loggedInUserDetail.organisations[0].instances[0].instanceId);

                            if (this.loggedInUserDetail?.organisations[0]?.instances[0]?.instanceId) {
                                this.setSessionInstance(this.loggedInUserDetail.organisations[0].instances[0].instanceId);
                            }
                        } else {
                            this.router.navigate(['/home']);
                        }
                    }
                } else {
                    this.globalEmittersService.hideInstanceLogoutOption.next(false);
                    this.router.navigate(['/home']);
                }
            } else if (this.loggedInUserDetail?.license && this.loggedInUserDetail?.license.instanceTypeIndex == 4) {
                this.router.navigate(['/home']);
            }
            // else {
            //     // TODO Display the error popUp
            //     this.router.navigate(['/home']);
            //     this.user_utility.errorModelPopup('You are not added to any instace, contact admin to add you in instance!');
            // }
        }
    }

    async setSessionInstance(instanceId: string) {
        let instanceResponse = null;
        if (this.loggedInUserDetail.isSysAdmin) {
            instanceResponse = await this.managementApiService.getInstanceById(instanceId).toPromise();
            if (instanceResponse.success === true) {
                if (instanceResponse?.response) {
                    let instanceDetails = instanceResponse.response;
                    localStorage.setItem('currentInstanceName', instanceDetails?.name);
                    localStorage.setItem('currentInstanceId', instanceDetails?.instanceId);
                    localStorage.setItem('selectedInstanceDetails', JSON.stringify(instanceDetails));
                    localStorage.setItem('currentInstanceTypeName', instanceDetails?.instanceType?.name);
                    localStorage.setItem('currentAssetType', instanceDetails?.instanceAssetType?.name);
                    this.globalEmittersService.hideInstanceLogoutOption.next(true);
                    this.router.navigate(['/home']);
                }
            }
        } else {
            instanceResponse = await this.managementApiService.getInstanceByOrgId(localStorage.getItem('selectedOrgId')).toPromise();
            if (instanceResponse.success === true) {
                if (instanceResponse?.response) {
                    let instanceDetails = instanceResponse.response.find((m) => m.instanceId == instanceId);
                    localStorage.setItem('currentInstanceName', instanceDetails?.name);
                    localStorage.setItem('currentInstanceId', instanceDetails?.instanceId);
                    localStorage.setItem('selectedInstanceDetails', JSON.stringify(instanceDetails));
                    localStorage.setItem('currentInstanceTypeName', instanceDetails?.instanceType?.name);
                    localStorage.setItem('currentAssetType', instanceDetails?.instanceAssetType?.name);

                    this.globalEmittersService.hideInstanceLogoutOption.next(true);
                    this.router.navigate(['/home']);
                }
            }
        }
    }

    getDecodedAccessToken(token: string): any {
        try {
            return jwt_decode(token);
        } catch (Error) {
            return null;
        }
    }

    setLoginDisplay() {
        this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
    }

    checkAndSetActiveAccount() {
        let activeAccount = this.authService.instance.getActiveAccount();

        if (!activeAccount && this.authService.instance.getAllAccounts().length > 0) {
            let accounts = this.authService.instance.getAllAccounts();
            this.authService.instance.setActiveAccount(accounts[0]);
        }
    }

    async login(userFlowRequest?: RedirectRequest | PopupRequest) {
        if (this.msalGuardConfig.interactionType === InteractionType.Popup) {
            if (this.msalGuardConfig.authRequest) {
                await this.authService.instance.handleRedirectPromise();
                this.authService
                    .loginPopup({ ...this.msalGuardConfig.authRequest, ...userFlowRequest } as PopupRequest)
                    .pipe(takeUntil(this._destroying$))
                    .subscribe((response: AuthenticationResult) => {
                        this.authService.instance.setActiveAccount(response.account);
                        this.getFullUserData();
                    });
            } else {
                await this.authService.instance.handleRedirectPromise();
                this.authService
                    .loginPopup(userFlowRequest)
                    .pipe(takeUntil(this._destroying$))
                    .subscribe((response: AuthenticationResult) => {
                        this.authService.instance.setActiveAccount(response.account);
                        this.getFullUserData();
                    });
            }
        }
    }

    logout() {
        this.authService.logoutPopup();
        localStorage.clear();
        this.router.navigate(['/landing']);
    }

    async Signup() {
        let signUpFlowRequest = {
            scopes: environment.scopes,
            authority: environment.b2cPolicies.authorities.signUp.authority,
        };

        await this.authService.instance.handleRedirectPromise();
        this.login(signUpFlowRequest);
    }

    // * api call to trigger email
    triggerEmail() {
        let payload = new EmailNewOrgAdd();
        // if (this.currentlySignUpUser.profileContact?.lastName) {
        payload.lastName = this.currentlySignUpUser.profileContact?.lastName ? this.currentlySignUpUser.profileContact?.lastName : '';
        payload.firstName = this.currentlySignUpUser.profileContact?.firstName ? this.currentlySignUpUser.profileContact?.firstName : '';
        // payload.email = this.currentlySignUpUser.profileContact?.email;
        // } else if (this.currentlySignUpUser.profileContact?.firstName) {
        //     payload.lastName = this.currentlySignUpUser.profileContact?.firstName;
        // }
        // else {
        //    payload.email = this.currentlySignUpUser.profileContact?.email;
        // }
        payload.email = this.currentlySignUpUser.profileContact?.email;
        this.emailSenderService
            .emailHandler(EmailType.DemoUserSignUp, [this.currentlySignUpUser.profileContact?.email], payload)
            .pipe(takeUntil(this._destroying$))
            .subscribe(
                (res) => {
                    if (res.success) {
                        // TODO Email sent successfully
                    }
                },
                (err) => {}
            );
    }

    user() {
        this.isUserShown = !this.isUserShown;
        if (this.isUserDropdownOpen) {
            this.isUserDropdownOpen = false;
        }
        this.isUserDropdown = !this.isUserDropdown;
    }

    ngOnDestroy(): void {
        this._destroying$.next(undefined);
        this._destroying$.complete();
    }
}
